const ROOT = "collapsibleListComponent";
const NEW_PAIR_BUTTON = "CollapsibleListNewPair_button";
const COLLAPSIBLE_LIST_ITEM = "collapsibleListItem";
const COLLAPSIBLE_LIST_ITEM_TITLE = "collapsibleListItemTitle";
const COLLAPSIBLE_LIST_ITEM_BODY = "collapsibleListItemBody";
const EXPAND_BUTTON = "collapsibleListExpandButton";
const TOOLBAR_DELETE_BUTTON = "blockButton_delete";
const MODAL_ROOT = "collapsibleListModal";

export { COLLAPSIBLE_LIST_ITEM, COLLAPSIBLE_LIST_ITEM_BODY, COLLAPSIBLE_LIST_ITEM_TITLE, EXPAND_BUTTON, MODAL_ROOT, NEW_PAIR_BUTTON, ROOT, TOOLBAR_DELETE_BUTTON };
//# sourceMappingURL=data-hooks.js.map
